import useStaticStores from "hooks/store/useStaticStores";

import { baseRestApi } from "../../baseRestApi";
import { BrokerContractType } from "./types/BrokerContractType";

module.hot?.accept();

const brokerBidContractApi = baseRestApi.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    getBrokerBidContract: builder.query<BrokerContractType, { brokerToken: string }>({
      query: ({ brokerToken }) => ({ url: `broker/contracts/${brokerToken}`, method: "GET" }),
      transformResponse: (response: { data: { contractRequest: BrokerContractType } }) => response.data.contractRequest,
    }),
  }),
});

export default brokerBidContractApi;
const { useGetBrokerBidContractQuery: useGBBCQ } = brokerBidContractApi;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useGetBrokerBidContractQuery = () => {
  const brokerToken = useStaticStores((state) => state.authSlice.brokerToken);
  return useGBBCQ({ brokerToken: brokerToken ?? "" });
};
